export const domains = {
  production: [
    "the.select",
  ],
  development: [
    "web.getselect.co",
    "s12e.co",
    "localhost",
    "localhost:3000",
    "localhost.com",
    "localhost.com:3000",
    "selectlocal.com",
    "selectlocal.com:3000",
  ],
};

// Production reads index.html's window.__ENV__, which 40-react-env-vars.sh fills
// at container start. Placeholders inlined into the bundle get constant-folded
// by the minifier before the container ever substitutes them.
const env: RuntimeEnv = import.meta.env.DEV ? import.meta.env : window.__ENV__;

export const Env = env.REACT_APP_ENV as string;
export const HomeURL = env.REACT_APP_HOME_URL as string;
export const CookieDomain = env.REACT_APP_COOKIE_DOMAIN as string;
export const GoogleAnalyticsCode = env.REACT_APP_GOOGLE_ANALYTICS_CODE;
export const SessionApiOrigin =
  env.REACT_APP_SESSION_API_ORIGIN ||
  (Env === "production" ? "https://api.the.select" : "https://api.s12e.co");
export const privacyPolicyLink =
  Env === "production"
    ? "https://the.select/privacy"
    : "https://s12e.co/privacy";
